<template>
  <div 
    class="sc-message--preview"
    v-ripple 
    role="button" 
    :id="message.id"
  >
    <div class="sc-message--location">

      <gmap-map
        :center="message.data"
        :zoom="10"
        :style="{'width': '100%', 'height': '100%'}"
        :options="{
          disableDefaultUi: true
        }"
      >
        <gmap-marker
          :position="message.data"
          :clickable="true"
          @click="message.data"
        />
      </gmap-map>      
    </div>

    <div class="sc-message--preview-state">
      <MessageState :state="state" :time="time" background />
    </div>
  </div>
</template>

<style>
  .sc-message--location {
    width:inherit; 
    height:inherit;
    border-radius:inherit;
  }
</style>

<script>
  import MessageState from './MessageState.vue'
  import timeUtils from '@utils/timeUtils'

  export default {
    components: { 
      MessageState
    },
    props: {
      message: {
        type: Object,
        required: true
      }
    },
    computed: {
      timerIcon() {
        return this.message.state == this.states.MessageRead ? 'history' : 'visibility'
      },
      hasTimerIcon() {
        return this.message.data.ttl != 0 && !this.message.sent
      },
      time() {
        return timeUtils.getShortTime(this.message.time);
      },
      state() {
        return this.message.sent ? this.message.state : null
      }
    }
  }
</script>
